// Bump this when privacy policy / cookie disclosure changes substantively.
// vanilla-cookieconsent reads this as `revision`; mismatch forces re-prompt.
export const CONSENT_VERSION = "2026-05-07";

export const CONSENT_COOKIE_NAME = "journail_cc";
export const REGION_COOKIE_NAME = "journail_region";
export const SUBJECT_COOKIE_NAME = "journail_consent_subject";

export const CATEGORY_KEYS = ["necessary", "analytics", "marketing"] as const;
export type CategoryKey = (typeof CATEGORY_KEYS)[number];
